import { Copy, Pinned, Remove } from "../../assets/icons";

export const iconDropdownOptions = [
    {
        id: 1,
        value: "pinProject",
        name: "Pin project",
        icon: <Pinned size={20} />,
        diabled: false,
    },
    {
        id: 2,
        value: "duplicate",
        name: "Duplicate",
        icon: <Copy size={20} />,
        diabled: false,
    },
    {
        id: 3,
        value: "remove",
        name: "Remove",
        icon: <Remove size={20} />,
        diabled: false,
    },
];


export const iconDropdownOptionsForCustomer = [
    {
        id: 1,
        value: "pinProject",
        name: "Pin project",
        icon: <Pinned size={20} />,
        diabled: false,
    }
];

export const otherIconDropdownOptions = [
    {
        id: 1,
        value: "pinProject",
        name: "Pin project",
        icon: <Pinned size={20} />,
        diabled: false,
    },
    {
        id: 2,
        value: "duplicate",
        name: "Duplicate",
        icon: <Copy size={20} />,
        diabled: false,
    }
];
